import { get } from "lodash";

export const findExistingStatus = (existingProcess, screen) => {
  const statuses = get(existingProcess, "processStatuses") || [];
  return (
    statuses.find((status) => status.id === screen.statusId) ||
    statuses.find(
      (status) =>
        status.name &&
        screen.name &&
        status.name.toLowerCase() === String(screen.name).toLowerCase(),
    )
  );
};

export const pickLiveScreen = (status) => {
  const screens = get(status, "screens") || [];
  return (
    screens.find((screen) => get(screen, "currentPublishedVersion.id")) ||
    screens[0] ||
    null
  );
};

/**
 * Overwriting a process must reuse the live screen on that status. Exported
 * screen ids are only a hint: AddScreen / AddScreenVersion with those ids
 * fail when the rows already exist.
 */
export const resolveEmbeddedScreenWrite = (screen, existingProcess) => {
  const existingStatus = findExistingStatus(existingProcess, screen);
  const liveScreen = pickLiveScreen(existingStatus);
  const statusId = get(existingStatus, "id") || screen.statusId;
  const version = get(liveScreen, "currentPublishedVersion") || {};

  if (get(liveScreen, "id") && version.id) {
    return {
      mode: "update",
      statusId,
      screenId: liveScreen.id,
      versionId: version.id,
      versionNumber: version.versionNumber,
      bindingManifestId: get(version, "bindingManifest.id"),
      translationTableId: get(version, "translationTable.id"),
      states: version.states || [],
    };
  }

  if (get(liveScreen, "id")) {
    return {
      mode: "add-version",
      statusId,
      screenId: liveScreen.id,
      versionNumber: version.versionNumber,
    };
  }

  return {
    mode: "create",
    statusId,
    screenId: null,
  };
};
